import React from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.css";

const NotFoundPage = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Oops! Page Not Found</h2>
        <p className="not-found-text">
          It looks like you've wandered off the path. The page you are looking
          for doesn't exist or has been moved.
        </p>
        <Link to="/" className="not-found-button">
          Return to Homepage
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
